export const BEARER_TOKEN = 'bearer_token';
export const EXPIRY_DATE = 'expiry_date';